import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';

const vesselRequests = (state = {
    data: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
    case actionTypes.GET_VESSEL_REQUESTS.REQUEST:
        return {
            ...state,
            data: [],
        };
    case actionTypes.GET_VESSEL_REQUESTS.SUCCESS: {
        const data = action.data.data.map((item) => {
            return {
                ...item,
                isUpdate: false,
            };
        });

        return {
            ...state,
            ...action.data,
            isLoaded: true,
            data,
        };
    }
    case actionTypes.GET_VESSEL_REQUESTS.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };


    case actionTypes.DELETE_VESSEL_REQUEST.REQUEST:
        return {
            ...state,
        };
    case actionTypes.DELETE_VESSEL_REQUEST.SUCCESS: {
        const data = state.data.map((item) => {
            if (item._id === action.vesselRequestId) {
                return {
                    ...item,
                    deleteBy: { email: action.email },
                    deleteAt: new Date(),
                };
            }

            return item;
        });

        return {
            ...state,
            data,
        };
    }
    case actionTypes.DELETE_VESSEL_REQUEST.FAILURE: {
        const data = state.data.map((item) => {
            if (item._id === action.vesselRequestId) {
                return {
                    ...item,
                    errors: action.errors,
                }
            }

            return item;
        });

        return {
            ...state,
            data,
        };
    }

    case actionTypes.UPDATE_VESSEL_REQUEST.REQUEST:
        return {
            ...state,
        };
    case actionTypes.UPDATE_VESSEL_REQUEST.SUCCESS: {
        const data = state.data.map((item) => {
            if (item._id === action.vesselRequestId) {
                return {
                    ...item,
                    isUpdate: false,
                }
            }

            return item;
        });

        return {
            ...state,
            data,
        };
    }
    case actionTypes.UPDATE_VESSEL_REQUEST.FAILURE: {
        const data = state.data.map((item) => {
            if (item._id === action.vesselRequestId) {
                return {
                    ...item,
                    isUpdate: true,
                    errors: action.errors,
                }
            }

            return item;
        });

        return {
            ...state,
            data,
        };
    }

    case actionTypes.POST_VESSEL_REQUEST.REQUEST:
        return {
            ...state,
            data: [],
        };
    case actionTypes.POST_VESSEL_REQUEST.SUCCESS: {
        const data = _.cloneDeep(state.data);
        data.push(action.vesselRequest);
        return { ...state, data, };
    }
    case actionTypes.POST_VESSEL_REQUEST.FAILURE:
        return { ...state };
    default:
        return state;
    }
};

export default vesselRequests;



// WEBPACK FOOTER //
// ./app/reducers/vessels/requests.js